import {
  ADD_ALL_CINEMAS,
  FETCH_ALL_CINEMAS,
  SET_SELECTED_CINEMA,
} from './cinemasTypes';

let initialState = {
  allCinemas: [],
  cinemasLoading: false,
  selectedCinema: null,
};

const cinemasReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_CINEMA:
      return { ...state, selectedCinema: action.payload };
    case ADD_ALL_CINEMAS:
      return {
        ...state,
        allCinemas: action.payload,
        cinemasLoading: false,
      };
    case FETCH_ALL_CINEMAS:
      return {
        ...state,
        allCinemas: [],
        cinemasLoading: true,
      };
    default:
      return state;
  }
};

export default cinemasReducer;
